import styled from 'styled-components'
import { useRef } from 'react'
import ClearButton from './ClearButton'
import ReplaceButton from './ReplaceButton'
import { breakpoint } from 'utils/consts/breakpoints'

const Actions = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  column-gap: 14px;
  position: absolute;
  inset: 0;
  background: rgba(18, 20, 50, 0.8);
`

export const Block = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  :hover ${Actions} {
    display: flex;
  }

  width: 154px;
  height: 154px;

  @media screen and ${breakpoint.s} {
    height: auto;
    width: auto;
  }
`

const Image = styled.img<{ readOnly?: boolean }>`
  cursor: ${props => (props.readOnly ? 'initial' : 'pointer')};
  width: 154px;
  height: 154px;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;

  @media screen and ${breakpoint.s} {
    width: 100%;
    height: 100%;
    aspect-ratio: 1/1;
  }
`

type LoadedImageProps = {
  value: string
  onChange: (file: File | string | null) => void
}

const LoadedImage = ({ value, onChange }: LoadedImageProps) => {
  const ref = useRef<HTMLInputElement>(null)
  const handleClear = () => {
    if (ref.current) {
      ref.current.value = ''
    }
    onChange(null)
  }
  return (
    <Block>
      <Image src={value} />
      <Actions>
        <ReplaceButton ref={ref} onChange={onChange} />
        <ClearButton onClick={handleClear} />
      </Actions>
    </Block>
  )
}

export default LoadedImage
